module.exports = __webpack_public_path__ + "img/user.78cf02fa.svg";